var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest } from "redux-saga/effects";
import { CONFIG } from "../../config/app.config";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import { getGeneralCreateFailureText, getGeneralCreateSuccessText, getGeneralRemoveFailureText, getGeneralRemoveSuccessText, getGeneralUpdateFailureText, getGeneralUpdateSuccessText, } from "../../utils/i18n/i18n.utils";
import { takeLatestWithUniquePayload } from "../utils/saga.utils";
import * as pricingActions from "./pricing.actions";
import * as pricingApi from "./pricing.api";
function getPricingStartFlow(action) {
    var payload, pricingId, pricing, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                pricingId = payload.pricingId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(pricingApi.getPricing, pricingId)];
            case 2:
                pricing = (_a.sent()).data;
                return [4 /*yield*/, put(pricingActions.getPricing.actions.success({
                        pricingId: pricingId,
                        pricing: pricing,
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pricingActions.getPricing.actions.failure({ pricingId: pricingId, error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function createPricingStartFlow(action) {
    var payload, createdPricing, unknownError_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(pricingApi.createPricing, payload)];
            case 2:
                createdPricing = (_a.sent()).data;
                return [4 /*yield*/, put(pricingActions.createPricing.actions.success(createdPricing))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralCreateSuccessText("pricing"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _a.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pricingActions.createPricing.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    message: getGeneralCreateFailureText("pricing"),
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function updatePricingStartFlow(action) {
    var payload, pricingId, pricing, updatedPricing, unknownError_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                pricingId = payload.pricingId, pricing = payload.pricing;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(pricingApi.updatePricing, pricingId, pricing)];
            case 2:
                updatedPricing = (_a.sent()).data;
                return [4 /*yield*/, put(pricingActions.updatePricing.actions.success({
                        pricingId: pricingId,
                        pricing: updatedPricing,
                    }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralUpdateSuccessText("pricing"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _a.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pricingActions.updatePricing.actions.failure({ pricingId: pricingId, error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    message: getGeneralUpdateFailureText("pricing"),
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function deletePricingStartFlow(action) {
    var payload, pricingId, unknownError_4, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                pricingId = payload.pricingId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(pricingApi.deletePricing, pricingId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(pricingActions.deletePricing.actions.success({ pricingId: pricingId }))];
            case 3:
                _a.sent();
                showAlert({
                    type: "success",
                    message: getGeneralRemoveSuccessText("pricing"),
                });
                return [3 /*break*/, 6];
            case 4:
                unknownError_4 = _a.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pricingActions.deletePricing.actions.failure({ pricingId: pricingId, error: error }))];
            case 5:
                _a.sent();
                showAlert({
                    type: "error",
                    message: getGeneralRemoveFailureText("pricing"),
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getPricingsPagedStartFlow(action) {
    var payload, identifier, page, _a, limit, filterData, skip, pricings, unknownError_5, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = action.payload;
                identifier = payload.identifier, page = payload.page, _a = payload.limit, limit = _a === void 0 ? CONFIG.DEFAULT_FETCH_LIMIT : _a, filterData = payload.filterData;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                skip = (page - 1) * limit;
                return [4 /*yield*/, call(pricingApi.getPricings, skip, filterData, limit)];
            case 2:
                pricings = (_b.sent()).data;
                return [4 /*yield*/, put(pricingActions.getPricingsPaged.actions.success({
                        identifier: identifier,
                        pricings: pricings,
                        page: page,
                    }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_5 = _b.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                return [4 /*yield*/, put(pricingActions.getPricingsPaged.actions.failure({
                        identifier: identifier,
                        page: page,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(pricingActions.getPricing.types.START, getPricingStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(pricingActions.createPricing.types.START, createPricingStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(pricingActions.updatePricing.types.START, updatePricingStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(pricingActions.deletePricing.types.START, deletePricingStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatestWithUniquePayload(function (_a) {
                        var payload = _a.payload;
                        return payload.identifier;
                    }, pricingActions.getPricingsPaged.types.START, getPricingsPagedStartFlow)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
